import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useModal } from '../context';
import Checkbox from 'components/common/checkbox/checkbox';
import { Button, ButtonWrapper } from 'components/common/button/button';
import { useAppDispatch } from 'redux/use-hooks';
import { connectWalletAndResolveAccess } from 'utils/connect-wallet-and-resolve-access';
import TermsOfUseContent from 'components/legal/terms-of-use-content';

import {
  StyledContainer,
  StyledSection,
  StyledHeading,
  StyledBlockWithScroll,
  StyledTextCheckbox
} from './views.style';

const TermView = ({ closeModal }: { closeModal: () => void }) => {
  const [disabled, setDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const { openModal } = useModal();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      // Close Terms first so wallet picker is not blocked / auto-skipped.
      closeModal();
      await new Promise((resolve) => setTimeout(resolve, 50));
      await connectWalletAndResolveAccess({
        dispatch,
        openModal,
        closeModal,
        navigate,
        forceConnect: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledContainer>
      <StyledSection p="17px 35px 24px 34px ">
        <StyledHeading fontWeight="bold" mb="17px">
          TERMS OF USE OF OFP WALLET
        </StyledHeading>
        <StyledBlockWithScroll>
          <TermsOfUseContent includeTitle={false} />
        </StyledBlockWithScroll>
        <StyledTextCheckbox>
          By ticking, you are confirming that you have read, understood and
          agree to OFP terms and conditions
          <Checkbox
            onChange={(checked) => setDisabled(!checked)}
            type="secondary"
          />
        </StyledTextCheckbox>
        <ButtonWrapper>
          <Button
            disabled={disabled || isLoading}
            loading={isLoading}
            fullwidth
            onClick={handleContinue}
          >
            Continue
          </Button>
        </ButtonWrapper>
      </StyledSection>
    </StyledContainer>
  );
};

export default TermView;
